<template>
    <section class="monitoringProviderOdfStackReceived">
        <h2>Received files</h2>
        <label v-show="empty">Waiting for new files...</label>
        <ul v-show="!empty">
          <li v-for="file in files" :key="file">
            {{ file }}
          </li>
        </ul>
    </section>
</template>

<script>
export default {
  name: 'monitoringProviderOdfStackReceived',
  computed: {
    empty () { return this.files?.length === 0 },
    files () { return this.$store.getters['ProviderOdf/filesReceived'] }
  }
}
</script>

<style>
.monitoringProviderOdfStackReceived{
  color: white
}
</style>
